import { IExpenseClaim } from 'Interfaces/expenseClaim';
import { FC, createContext, useState } from 'react';

interface IExpenseClaimContext {
  claims: IExpenseClaim[];
  addClaim: (claim: IExpenseClaim) => void;
  editClaim: (claim: IExpenseClaim, claimIndex: number) => void;
  deleteClaim: (claimIndex: number) => void;
  claimEditIndex: number | null;
  setClaimEditIndex: (index: number) => void;
}

export const ExpenseClaimContext = createContext<IExpenseClaimContext>({
  claims: [],
  addClaim: () => {},
  editClaim: () => {},
  deleteClaim: () => {},
  claimEditIndex: null,
  setClaimEditIndex: () => {},
});

export const claimInitialValues = {
  travelDate: undefined,
  isPublicTransport: false,
  publicTransportPrice: '',
  originPlace: '',
  destinationPlace: '',
};

interface IExpenseClaimContextProvider {}

export const ExpenseClaimContextProvider: FC<IExpenseClaimContextProvider> = (
  props
) => {
  const [claims, setClaims] = useState<IExpenseClaim[]>([]);
  const [claimEditIndex, setClaimEditIndex] = useState<number | null>(null);

  const addClaim = (claim: IExpenseClaim) =>
    setClaims((prevClaims) => [...prevClaims, claim]);

  const editClaim = (claim: IExpenseClaim, claimIndex: number) =>
    setClaims((prevClaims) => {
      const newClaims = [...prevClaims];
      newClaims[claimIndex] = claim;
      return newClaims;
    });

  const deleteClaim = (claimIndex: number) =>
    setClaims((prevClaims) =>
      prevClaims.filter((_, index) => index !== claimIndex)
    );

  return (
    <ExpenseClaimContext.Provider
      value={{
        claims,
        addClaim,
        editClaim,
        deleteClaim,
        claimEditIndex,
        setClaimEditIndex,
      }}
    >
      {props.children}
    </ExpenseClaimContext.Provider>
  );
};
